(function () {
  const STORAGE_KEY = 'fusion-mont-delivery-location-v3';

  function readDelivery() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function parseLabel(label) {
    const bits = String(label || '')
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean);
    const zip = (String(label).match(/\b\d{6}\b/) || [])[0] || '';
    const cityBit = bits.find((bit) => /bengaluru|bangalore|mysuru|mysore/i.test(bit));
    return {
      address1: bits.slice(0, Math.max(1, bits.length - 1)).join(', ') || label,
      city: cityBit || bits[bits.length - 1] || 'Bengaluru',
      zip: zip,
    };
  }

  function checkoutUrl() {
    const saved = readDelivery() || {};
    const parsed = parseLabel(saved.label || saved.address1 || '');
    const address1 = saved.address1 || parsed.address1;
    const city = saved.city || parsed.city;
    const zip = saved.zip || parsed.zip;
    const params = new URLSearchParams();
    params.set('checkout[shipping_address][country]', 'India');
    params.set('checkout[shipping_address][province]', saved.province || 'Karnataka');
    if (address1) params.set('checkout[shipping_address][address1]', address1);
    if (city) params.set('checkout[shipping_address][city]', city);
    if (zip) params.set('checkout[shipping_address][zip]', zip);
    return '/checkout?' + params.toString();
  }

  window.fusionCheckoutUrl = checkoutUrl;

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-fusion-checkout]');
    if (!link) return;
    event.preventDefault();
    window.location.href = checkoutUrl();
  });
})();
